// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"mJ","cardInnerHeading":"mK","toggleWrapperClass":"mL","textWrapperClass":"mM","toggleTextClass":"mN"};